import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { team, teamGroupImage } from '../mock';

const TeamPage = () => {
  return (
    <div className="App bg-white">
      <Header />
      <PageHero
        eyebrow="Our People"
        title="People who"
        italic="listen first."
        description="A team of registered physiotherapists, athletic therapists, and support staff—dedicated to evidence-informed care and warm, respectful conversations."
        image={teamGroupImage}
        imagePosition="center top"
        breadcrumbs={[{ label: 'Home', to: '/' }, { label: 'Our Team' }]}
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-[1240px] mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {team.map((m) => (
            <Link key={m.slug} to={`/team/${m.slug}`} className="group">
              <div className="rounded-[20px] overflow-hidden aspect-[4/5] bg-neutral-100">
                <img src={m.photo} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" style={{ objectPosition: m.photoPosition || 'center center', transform: m.photoScale ? `scale(${m.photoScale})` : undefined }} loading="lazy" />
              </div>
              <div className="mt-4">
                <span className="text-[11px] font-semibold tracking-[0.15em] uppercase text-[#CA0028]">{m.role}</span>
                <h3 className="mt-1 text-[18px] font-semibold text-neutral-900 group-hover:text-[#CA0028] transition-colors">{m.name}</h3>
                <p className="mt-1 text-[13px] text-neutral-500">{m.focus.join(' · ')}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TeamPage;
